import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('mq_user');
    const token  = localStorage.getItem('mq_token');
    if (stored && token) {
      setUser(JSON.parse(stored));
      // Verify token is still valid
      authAPI.me()
        .then(r => setUser(r.data))
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await authAPI.login(email, password);
    localStorage.setItem('mq_token', data.token);
    localStorage.setItem('mq_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  // Despues de que alguien cambia SU contrasena, el backend devuelve un token
  // nuevo ya sin la marca de temporal. Se guarda y se baja la bandera para que
  // la puerta de App.js deje pasar, sin obligar a entrar otra vez.
  const aplicarPassword = (data) => {
    if (data && data.token) localStorage.setItem('mq_token', data.token);
    setUser(prev => {
      const u = { ...prev, must_change_password: false };
      localStorage.setItem('mq_user', JSON.stringify(u));
      return u;
    });
  };

  const logout = () => {
    localStorage.removeItem('mq_token');
    localStorage.removeItem('mq_user');
    setUser(null);
  };

  const isAdmin   = user?.role === 'admin';
  const isManager = ['admin','manager'].includes(user?.role);
  const isVendor  = ['admin','manager','vendor'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isManager, isVendor, aplicarPassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
